import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, Subject, tap } from 'rxjs';
import { ApiManagerService } from '../api-manager/api.maganer.service';
import { SportAlgoUtils } from './sport.algo';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class EventsService {
  layerSub = new Subject<any>();
  planlist: any;

  constructor(private httpClient: HttpClient, private api: ApiManagerService) { }

  getEvents(layer: number = 0, lid: number, enaOrig?: string){
    let endpoint = layer ? `user/${lid}/events/${enaOrig}` : `user/${lid}/events/all`;
    return this.httpClient.get(`${environment.spooortsSportApi}${endpoint}`);
  }

  addToFavorit(id: number, token: string){
    const endpoint = `event/${id}/favorite/add`;
    const headers = {
      Authorization: `Bearer ${token}`
    };

    return this.httpClient.get(
      `${environment.spooortsSportApi}${endpoint}`,
      { headers }
    );
  }

  getPlanList(token: string){
    return new Promise<any>((resolve, reject) => {
      const headers = {
        Authorization: `Bearer ${token}`
      };
      this.httpClient.get(`${environment.spooortsTournamentApi}user/${token}/tournament/all`, {headers}).subscribe((results:any) => {
        this.planlist = results;
        this.filterAll();
        resolve(this.planlist);
      });
    });
  }

  getQrCode(token: string, eventId: any){
    return new Promise<any>((resolve, reject) => {
      const headers = {
        Authorization: `Bearer ${token}`
      };
      this.httpClient.get(`${environment.spooortsSportApi}event/${eventId}/registration/qrcode`, {headers}).subscribe((qrcode:any) => { 
        resolve(qrcode.content);
      });
    });
  }

  filterAll() {
    for (let i = 0; i < this.planlist?.length; i++) {
        switch (this.planlist[i].plantype) {
            case PlanEnum.PlanOnePage: this.planlist[i] = SportAlgoUtils.transformJgj(this.planlist[i]); break;
            case PlanEnum.KoPage: this.planlist[i] = SportAlgoUtils.transformKo(this.planlist[i]); break;
            case PlanEnum.VorPage: this.planlist[i] = SportAlgoUtils.transformVor(this.planlist[i]); break;
            case PlanEnum.VorKoPage: this.planlist[i] = SportAlgoUtils.transformVorKo(this.planlist[i]); break;
            case PlanEnum.MePage: this.planlist[i] = SportAlgoUtils.transformMeKo(this.planlist[i]); break;
        }
    }
}

  getMyEvents(token: string){
    const headers = {
      Authorization: `Bearer ${token}`
    };
    return this.httpClient.get(`${environment.spooortsSportApi}events`, {headers});
  }

  getEventDetails(id: number): Promise<any>{
    return fetch(`${environment.spooortsSportApi}event/${id}/details`).then((results) => results.json());
  }

  getEventMap(id: number):Promise<any>{
    return fetch(this.api.getApi() + "revt/itms/mapinit?ids=" + id).then((results) => results.json());
  }

  isRegistered(eventId: string, token: string):Promise<any>{
    const headers = {
      Authorization: `Bearer ${token}`
    };
    return fetch(`${environment.spooortsSportApi}event/is-registered?id=${eventId}`, {headers}).then((results) => results.json());
  }

  getEventPaymentDetails(eventId: number, lang: string){
    return this.httpClient.get(`${environment.spooortsAdminApi}event/${eventId}/checkout?lang=${lang}`);
  }

  executeCoupon(coupon: any){
    let path = `user/${coupon.token}/coupon/use?amount=${coupon.amount}&lang=${coupon.lang}&code=${coupon.code}`;
    return this.httpClient.get<any>(`${environment.spooortsBackofficeApi}` + path);
  }

  eventPaymentIntent(path: string){
    return this.httpClient.get(`${environment.spooortsAdminApi}` + path, { responseType: 'text' });
  }

  savePayment(token: string, eventId: string): Observable<any> {
    let httpParams = new HttpParams();
    httpParams = httpParams.append('token', token);
    httpParams = httpParams.append('evId', eventId);
    const headers = {
      Authorization: `Bearer ${token}`
    };

    let options = {
      headers,
      params: httpParams
    }
    return this.httpClient.post(`${environment.spooortsSportApi}event/${eventId}/register`, null, options).pipe(
      tap((response: any) => {
        console.log('response: ', response);
      })
    );
  }
}


export enum PlanEnum {
  "PlanOnePage",
  "KoPage",
  "VorPage",
  "VorKoPage",
  "GruKoPage",
  "GruKoPlPage",
  "GruPlPage",
  "MePage",
  "Scratch"
}